import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { DocumentDetailPage } from "@client/components/kb/document-detail-page";
import { useKbSearch } from "../route";

const DOC_VIEW_TABS = ["chunks", "structure", "metadata", "logs"] as const;
type DocViewTab = (typeof DOC_VIEW_TABS)[number];
const DOC_VIEW_TAB_SET = new Set<string>(DOC_VIEW_TABS);

function isValidDocViewTab(v: unknown): v is DocViewTab {
  return typeof v === "string" && DOC_VIEW_TAB_SET.has(v);
}

export const Route = createFileRoute("/_app/kb/$kbId/$docId")({
  validateSearch: (search: Record<string, unknown>) => ({
    view: isValidDocViewTab(search.view) ? search.view : "chunks",
    chunkId: typeof search.chunkId === "string" ? search.chunkId : undefined,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { kbId, docId } = Route.useParams();
  const { view, chunkId } = Route.useSearch();
  const search = useKbSearch();
  const navigate = useNavigate({ from: "/kb/$kbId/$docId" });
  return (
    <DocumentDetailPage
      kbId={kbId}
      docId={docId}
      rightTab={view}
      initialChunkId={chunkId}
      backSearch={{
        space: search.space,
        packId: search.packId,
        topicId: search.topicId,
      }}
      onRightTabChange={(t) => navigate({ search: (prev) => ({ ...prev, view: t }), replace: true })}
    />
  );
}
